/* lua.js generated code 0.3.0 */

const ReplayDataFormatter = require("./Replay/ReplayDataFormatter")

ReplayManager = xClass("ReplayManager")
var _instance = null
var REPLAY_FILE_NAME = "test.rep"
ReplayManager.getInstance = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    // body
    if (!_instance) {
        _instance = ReplayManager.new()
        _instance.replayTable = table()
        _instance.formatter = new ReplayDataFormatter();
        //_instance.readReplay()
    }
    return _instance
}

ReplayManager.prototype.cleanup = function () {
    _instance.replayTable = table()
}

ReplayManager.prototype.readReplay = function () {
    var self = this
    // body
    var path = he.HeResPathUtils.getUserDataPath() + "/" + REPLAY_FILE_NAME
    var [hFile, err] = io.open(path, "r")
    var text
    if (hFile && !err) {
        text = hFile.read("*a")
        io.close(hFile)
    }
    if (text) {
        self.replayTable = table.deserialize(text) || table()
    } else {
        self.replayTable = table()
    }
}
ReplayManager.prototype.writeReplay = function (writeCbs = null) {
    var self = this
    if (self.createTime == undefined || self.createTime == 0) {
        self.createTime = new Date().getTime();
    }
    for(let i = 1; i <= $len(self.readReplay); i++) {
        self.replayTable[i].md5 = ResManager.getLevelMd5(self.replayTable[i].level)
    }
    var batchReplay = {
        replay: table.serialize2(self.replayTable),
        uid: UserManager.getInstance().uid,
        createTime: self.createTime
    }
    cc.UserDefault.getInstance().setStringForKey(LOCAL_LAST_BATCH_REPLAY_IN_LEVEL, JSON.stringify(batchReplay), writeCbs);
}
ReplayManager.prototype.sendLastToServer = function (replayTable) {
    var self = this
    try {
        var lastBatchReplay = cc.UserDefault.getInstance().getStringForKey(LOCAL_LAST_BATCH_REPLAY_IN_LEVEL);
        if(lastBatchReplay) {
            lastBatchReplay = JSON.parse(lastBatchReplay)
            var http = ReplayHttp.new(true);
            // http.addEventListener(Events.kComplete, removeKey);
            // http.addEventListener(Events.kError, removeKey);
            // http.load(table([1, "content", lastBatchReplay.replay]))
            http.load(table([1, "content", this.formatter.format(lastBatchReplay.replay)]))
        }
    } catch (e) {
        console.warn("ReplayManager.sendLastToServer failed", e);        
        logCenter.error(e, 'ReplayError')
    } finally {
        self.createTime = 0
        cc.UserDefault.getInstance().removeKey(LOCAL_LAST_BATCH_REPLAY_IN_LEVEL);
    }
}
ReplayManager.prototype.removeReplayRecord = function (replayTable) {
    let self = this
    self.createTime = 0
    cc.UserDefault.getInstance().removeKey(LOCAL_LAST_BATCH_REPLAY_IN_LEVEL);
}
ReplayManager.prototype.updateReplayTable = function (replayTable) {
    var self = this
    // body
    self.replayTable = replayTable
    self.writeReplay()
}
ReplayManager.prototype.dcErrorGameReplay = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    // body
    var allReplay = self.getAllReplay()
    if (allReplay && type(allReplay) === "table" && $len(allReplay) > 0) {
        var needOverWrite = false
        var deleteNum = 0
        for (var k = 1; k <= 20; k += 1) {
            var index = $len(allReplay) + deleteNum - k + 1
            if (index > 0) {
                var replay = allReplay[index]
                if (!replay.isOver) {
                    DCAssist.dcForErrorGameReplay(table.serialize(replay), replay.level)
                    table.remove(allReplay, index)
                    needOverWrite = true
                    deleteNum = deleteNum + 1
                }
            }
        }
        //-upload replays which control by maintance
        var uid = UserManager.getInstance().getUserRef().uid
        var level = MaintenanceManager.getInstance().getNeedUploadReplayLevel(uid)
        if (level) {
            var replayUploadList = table()
            var replayList = table()
            for (var k = 1, v = allReplay[1]; v; k++ , v = allReplay[k]) {
                if (v.level === level) {
                    table.insert(replayUploadList, v)
                } else {
                    table.insert(replayList, v)
                }
            }
            if ($len(replayUploadList) > 0) {
                DCAssist.dcForErrorGameReplay(table.serialize(replayUploadList), level)
                self.replayTable = replayList
                needOverWrite = true
            }
        }
        if (needOverWrite) {
            self.writeReplay()
        }
    }
}
ReplayManager.prototype.getAllReplay = function () {
    var self = this
    // body
    return self.replayTable
}
ReplayManager.prototype.getLastReplay = function () {
    var self = this
    // body
    var count = $len(self.replayTable)
    if (count > 0) {
        return self.replayTable[count]
    }
    return null
}
ReplayManager.prototype.getLastReplayByLevelId = function (level) {
    var self = this
    // body
    var count = $len(self.replayTable)
    if (count > 0) {
        var $var33 = count
        for (var k = $var33; k >= 1; k += -1) {
            var replay = self.replayTable[k]
            if (replay.level === level) {
                return replay
            }
        }
    }
    return null
}
